import React, { useState } from "react";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  Image,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

interface ImageCarouselProps {
  images: string[];
}

export const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  if (images.length === 0) {
    return null;
  }

  return (
    <div className="tw-relative">
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={100}
        totalSlides={images.length}
        isIntrinsicHeight={true}
        currentSlide={currentSlide}
      >
        <div className="tw-relative">
          <Slider>
            {images.map((imageUrl, index) => (
              <Slide index={index} key={imageUrl}>
                <div className="tw-flex tw-justify-center tw-items-center tw-bg-gray-50 tw-rounded tw-p-2">
                  <Image
                    src={imageUrl}
                    hasMasterSpinner={true}
                    className="tw-max-h-64 tw-w-auto tw-object-contain"
                  />
                </div>
              </Slide>
            ))}
          </Slider>

          {/* Navigation Buttons */}
          {images.length > 1 && (
            <>
              <ButtonBack
                onClick={() => setCurrentSlide((prev) => Math.max(0, prev - 1))}
                className="tw-absolute tw-left-2 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-bg-white tw-rounded-full tw-p-2 tw-shadow-md hover:tw-bg-gray-100 tw-border tw-border-gray-300"
              >
                <svg
                  className="tw-w-5 tw-h-5 tw-text-gray-700"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </ButtonBack>
              <ButtonNext
                onClick={() =>
                  setCurrentSlide((prev) =>
                    Math.min(images.length - 1, prev + 1)
                  )
                }
                className="tw-absolute tw-right-2 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-bg-white tw-rounded-full tw-p-2 tw-shadow-md hover:tw-bg-gray-100 tw-border tw-border-gray-300"
              >
                <svg
                  className="tw-w-5 tw-h-5 tw-text-gray-700"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </ButtonNext>
            </>
          )}
        </div>

        {/* Slide Indicators */}
        {images.length > 1 && (
          <div className="tw-flex tw-justify-center tw-gap-2 tw-mt-3">
            {images.map((imageUrl, index) => (
              <button
                key={imageUrl}
                onClick={() => setCurrentSlide(index)}
                className={`tw-w-2 tw-h-2 tw-rounded-full tw-transition-colors ${
                  currentSlide === index
                    ? "tw-bg-blue-600"
                    : "tw-bg-gray-300 hover:tw-bg-gray-400"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}
      </CarouselProvider>
    </div>
  );
};
